export default "__VITE_ASSET__CcbMUiJ$__"